import Cookies from 'js-cookie';

import { Tableau } from '../utils/TableauLog';
import { CookieKeys } from './IVizPortalCookies';

export namespace SessionService {

  // exporting for the purpose of testing
  export enum SessionState {
    Exists,
    NoSession,
    Unknown
  }

  let sessionState = SessionState.Unknown;

  // Tableau Server sets two session cookies:
  // `workgroup_session_id`, which is not accessible to scripts (Http-Only)
  // `XSRF-TOKEN` is by design made available to scripts
  // All usages of this cookie should got through here, except in OneOffStaticScripts
  export function getSessionId(): string {
    return Cookies.get(CookieKeys.XsrfToken);
  }

  export function setSessionId(ticket: string): void {
    Tableau.Logger().info('set session to ' + ticket);
    sessionState = SessionState.Exists;
    Cookies.set(CookieKeys.XsrfToken, ticket);
  }

  function clearSessionId(): void {
    Tableau.Logger().info('clear session id');
    Cookies.remove(CookieKeys.XsrfToken);
  }

  export function isSessionStateUnknown(): boolean {
    Tableau.Logger().info('checking if session is Unknown(2): it is ' + sessionState);
    return sessionState === SessionState.Unknown;
  }

  export function getSessionCookieName(): string {
    return CookieKeys.XsrfToken;
  }

  export function endSession(message: string): void {
    Tableau.Logger().info('ending session: ' + message);
    sessionState = SessionState.NoSession;
    clearSessionId();
  }

  // eventually this should go away? we should be able to set the cookie when we create a session
  export function createSession(): void {
    sessionState = SessionState.Exists;
  }

  export function isSessionCurrentlyValid(): boolean {
    return sessionState === SessionState.Exists;
  }
}

export type SessionService = typeof SessionService;